/**
 * Polyfill for using the .closest() without jQuery
 */
 if (!Element.prototype.matches) {
    Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;

        do {
        if (Element.prototype.matches.call(el, s)) return el;
        el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}





function openTab(evt, tabName) {
    let i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("profile__main");

    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }

    tablinks = document.querySelectorAll(".profile__nav li button");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    document.getElementById(tabName).style.display = "block";
    evt.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
const defaultOpen = document.getElementById("defaultOpen");
if( defaultOpen ) {
    defaultOpen.click();
}


function profileMenuToggle() {
    let profileNav = document.querySelector(".profile__nav");

    if (!profileNav) return;

    profileNav.addEventListener("click", function () {
        this.classList.toggle("profile__nav--active");
    });
}

function addressToggle() {
    let addressForm = document.querySelector("#address-form");
    let addAddressBtn = document.querySelector("#add-address");

    if(
        addressForm
        && addAddressBtn
    ) {
        addAddressBtn.addEventListener("click", function () {
           addressForm.style.display = "block";
        });
    }
}


function tableToggle() {
    let sizeBtn = document.querySelector("#btn-size");
    let bodyBtn = document.querySelector("#btn-body");
    let sizeTable = document.querySelector("#table-size");
    let bodyTable = document.querySelector("#table-body");

    if (sizeBtn && sizeTable) {
        bodyTable.style.display = "none";
        sizeBtn.style.borderBottom = "1px solid #000";
    }

    if (sizeBtn) {
        sizeBtn.addEventListener("click", function () {
            this.style.borderBottom = "1px solid #000";
            bodyBtn.style.borderBottomColor = "transparent";
            sizeTable.style.display = "table";
            bodyTable.style.display = "none";
        });
    }

    if (bodyBtn) {
        bodyBtn.addEventListener("click", function () {
            this.style.borderBottom = "1px solid #000";
            sizeBtn.style.borderBottomColor = "transparent";
            bodyTable.style.display = "table";
            sizeTable.style.display = "none";
        });
    }
}

function modalStarter(btn, modal, close, block) {
    let btnListeners = document.querySelectorAll(btn);

    let modalWindow = document.querySelector(modal);
    let closeBtn = document.querySelector(close);
    let modalBlock = document.querySelector(block);
    let activeClass = block.replace('.', "") + "--active";

    // if (closeBtn) {
        document.querySelectorAll(close).forEach(el => {
            el.addEventListener("click", function (e) {
                modalWindow.classList.remove("modal--active");
                modalBlock.classList.remove(activeClass);
            });
        })
    // }

    window.addEventListener("click", function (e) {
        if (event.target == modalWindow) {
            modalWindow.classList.remove("modal--active");
            modalBlock.classList.remove(activeClass);
        }
    });

    // btnListeners.forEach(btnListener => {
    //     btnListener.addEventListener("click", function (e) {
            
    $(document).on('click', `${ btn }`, function(e) {
        e.preventDefault();
        modalBlock.classList.add(activeClass);
        modalWindow.classList.add("modal--active");
    });

    //     });
    // })
}

function menuToggle() {
    let menuBtn = document.querySelector(".menu-toggle");
    let headerNav = document.querySelector(".header__nav");

    if (!menuBtn) return;

    menuBtn.addEventListener("click", function () {
        
        if( document.body.classList.contains('show-cart') ) {
            document.querySelector("#modal-cart").classList.remove("modal--active");
            document.querySelector(".cart").classList.remove("cart--active");
            document.body.classList.remove('show-cart');

            return;
        }
        

        
        this.classList.toggle("is-active");
        headerNav.classList.toggle("header__nav--mobile");

        

        if(this.classList.contains('is-active')) {
            document.body.classList.add('overflow-hidden');
        } else {
            document.body.classList.remove('overflow-hidden');
        }
    });
}

// function cookieModal() {
//     let modal = document.querySelector("#cookie-modal");
//     let closeBtn = document.querySelector(".modal__close-btn");
//     let agreeBtn = document.querySelector("#btn-agree");

//     if (!closeBtn) return;

//     closeBtn.onclick = function () {
//         modal.classList.remove("modal--active", "modal--end");
//         newsModal();
//     }

//     agreeBtn.onclick = function () {
//         modal.classList.remove("modal--active", "modal--end");
//         newsModal();
//     }

//     // When the user clicks anywhere outside of the modal, close it
//     window.onclick = function (event) {
//         if (event.target == modal) {
//             modal.classList.remove("modal--active", "modal--end");
//             newsModal();
//         }
//     }

//     function cookieWindowStarter() {
//         modal.classList.add("modal--active", "modal--end");
//     }

//     setTimeout(cookieWindowStarter, 2000);
// }



function searchModal() {
    let modal = document.querySelector("#modal-search");
    let closeBtn = document.querySelector(".search-block__close-btn");
    let searchBtn = document.querySelectorAll(".search-link");

    if (!closeBtn) return;

    closeBtn.onclick = function (e) {
        e.preventDefault();
        modal.classList.remove("modal--active", "modal--start");
        // document.body.classList.remove('overflow-hidden');
    }

    // When the user clicks anywhere outside of the modal, close it
    window.addEventListener("click", function (e) {
        if (event.target == modal) {
            modal.classList.remove("modal--active", "modal--start");
            // document.body.classList.remove('overflow-hidden');
        }
    });

    searchBtn.forEach(item => {
        item.addEventListener("click", function (e) {
            e.preventDefault();
            // const rect = document.querySelector('.section-header').getBoundingClientRect();
            // const topOffset = rect.top + rect.height;

            modal.classList.add("modal--active", "modal--start");
            // modal.style.top = `${ topOffset }px`;
            // document.body.classList.add('overflow-hidden');
            setTimeout(function() {
                modal.querySelector('.search-block__input').focus();
            }, 300);
        });
    });
}

function cartModal() {
    let cartModal = document.querySelector("#modal-cart");
    let cartBtn = document.querySelectorAll(".cart-link");
    let cartCloseBtn = document.querySelector(".cart__close-btn");
    let cartModalBlock = document.querySelector(".cart");

    if (cartCloseBtn) {
        cartCloseBtn.addEventListener("click", function (e) {
            cartModal.classList.remove("modal--active");
            cartModalBlock.classList.remove("cart--active");
            document.body.classList.remove('show-cart');
        });
    }

    window.addEventListener("click", function (e) {
        if (event.target == cartModal) {
            cartModal.classList.remove("modal--active");
            cartModalBlock.classList.remove("cart--active");
            document.body.classList.remove('show-cart');
        }
    });

    if (cartBtn) {
        cartBtn.forEach(item => {
            item.addEventListener("click", function (e) {
                e.preventDefault();
                
                cartModalBlock.classList.add("cart--active");
                cartModal.classList.add("modal--active");

                document.body.classList.add('show-cart');
            });
        })
    }
}

function hideBanner() {
    let banner = document.querySelector(".header__top-box");
    let bannerHideBtn = document.querySelector(".header__top-box .btn-close");
    if(banner){
        bannerHideBtn.addEventListener("click", function () {
            $(banner).slideUp();
        });
    }

}

function scrollTop() {
    //Get the button:
    let scrollTopBtn = document.querySelectorAll("#scroll-top-btn, #scroll-top-btn--mobile");

    // When the user clicks on the button, scroll to the top of the document
    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    // if (scrollTopBtn) {
    //     scrollTopBtn.onclick = function () {
    //         topFunction();
    //     };
    // }

    $(scrollTopBtn).on('click', function() {
        topFunction();
    });
}

function sortBlockToggle() {
    let sortBtn = document.querySelector(".btn-sort");
    let sortBlock = document.querySelector(".sort-block");

    if (sortBtn && sortBlock) {
        sortBtn.addEventListener("click", function (e) {
            e.preventDefault();
            sortBlock.classList.toggle("sort-block--active")

            if( sortBlock.classList.contains('sort-block--active') ) {
                sortBtn.textContent = 'Close';
            } else {
                sortBtn.textContent = 'Sort by';
            }
        })
    }
}

// 
// Commenting because the trigger was converted to hover.
// 
// function shopBlockToggle() {
//     let shopLink = document.querySelector(".shop-link");
//     let shopBlock = document.querySelector(".shop-block");

//     if (shopLink && shopBlock) {
//         shopLink.addEventListener("click", function (e) {
//             e.preventDefault();
//             shopBlock.classList.toggle("shop-block--active");

//             if (window.innerWidth <= 768) {
//                 if (shopLink.innerHTML === "Shop") {
//                     shopLink.innerHTML = "Back";
//                 } else {
//                     shopLink.innerHTML = "Shop"
//                 }
//             }
//         })
//     }
// }
function changeGridViewchecker() {
    let largeMode = localStorage.getItem('largeMode'); 

    const largeModeToggle = document.querySelector('.btn-view-lg');

    let viewLargeBtn = document.querySelector(".btn-view-lg");
    let productGrid = document.querySelector(".product-grid");
    
    const enablelargeMode = () => {
      // 1. Add the class to the body
      document.body.classList.add('largeMode');
      // 2. Update largeMode in localStorage
      localStorage.setItem('largeMode', 'enabled');
      if (viewLargeBtn && productGrid) {
        productGrid.classList.add("product-grid--lg");
      }
    
      
    }
    
    const disablelargeMode = () => {
      // 1. Remove the class from the body
      document.body.classList.remove('largeMode');
      if (viewLargeBtn && productGrid) {
        productGrid.classList.remove("product-grid--lg");
      }
     
      // 2. Update largeMode in localStorage 
      localStorage.setItem('largeMode', null);
    }
     
    // If the user already visited and enabled largeMode
    // start things off with it on
    if(largeMode === null){
        enablelargeMode();
    }
    else if (largeMode === 'enabled') {
      enablelargeMode();
    }else{
        disablelargeMode(); 
    }
    if (viewLargeBtn && productGrid) {
       //
        // largeModeToggle.addEventListener('click', () => {
        $(document).on('click', '.btn-view-lg', function() {
        
            // get their largeMode setting
            largeMode = localStorage.getItem('largeMode'); 
            
            // if it not current enabled, enable it
            if (largeMode !== 'enabled') {
              enablelargeMode();
              console.log('on');
            // if it has been enabled, turn it off  
            } else {  
              disablelargeMode(); 
              console.log('off');
            }

        });
        //   });
    }
    // When someone clicks the button


}


function changeGridView() {
    let viewLargeBtn = document.querySelector(".btn-view-lg");
    let productGrid = document.querySelector(".product-grid");

    if (viewLargeBtn && productGrid) {
        // viewLargeBtn.classList.add("btn-view-lg--active");
        $('.btn-view-lg').addClass("btn-view-lg--active");
        
        $(document).on('click', '.btn-view-lg', function () {
            //history.pushState( '', '', `?view=large` )
            $(this).toggleClass("btn-view-lg--active")
            $('.product-grid').toggleClass("product-grid--lg");
        });

    }
}

function changeProductSizeOptions() {
    const optionBox = document.querySelector(".product__size-box");
    const sizeSelect = optionBox?.querySelector(".product__select-box");
    const options = sizeSelect?.querySelectorAll(".option");
    const title = optionBox?.querySelector(".product__size-value i");

    if (!optionBox) return

    options.forEach((option) => {
        const input = option?.querySelector("input");
        input.addEventListener('input', () => {
            if (input.checked && !input.disabled) {
                title.innerHTML = option?.querySelector(".check__box").textContent
            }
        });
    })
}

function changeProductColorOptions() {
    const colorBox = document.querySelector(".product__color-box");
    const colorSelect = colorBox?.querySelector(".product__select-box");
    const options = colorSelect?.querySelectorAll(".option");

    if (!colorBox) return;

    options.forEach((option) => {
        const input = option?.querySelector("input")
        const customInput = option?.querySelector(".check__box")
        let colorVal = input.getAttribute("data-color-value");
        let colorName = input.getAttribute("data-color-name")

        customInput.style.background = `${colorVal} content-box`;

        if (input.checked) {
            setColorVal(customInput, "--current-color", colorVal);
            setColorName(colorBox, colorSelect, colorName);
        }


        input.addEventListener('input', () => {
            if (input.checked) {
                setColorVal(customInput, "--current-color", colorVal);
                setColorName(colorBox, colorSelect, colorName);
            }
        });
    });
}

function setColorVal(element, varName, value) {
    element.style.setProperty(varName, value)
}

function setColorName(selectBox, select, color) {
    const title = selectBox?.querySelector(".product__color-name");

    title.innerHTML = color;
}

function customSelect() {
    let x, i, j, l, ll, selElmnt, a, b, c;
    x = document.getElementsByClassName("custom-select");
    l = x.length;
    for (i = 0; i < l; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        ll = selElmnt.length;
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        if(selElmnt.options[selElmnt.selectedIndex] != null){
            a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        }
        x[i].appendChild(a);
        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide");
        for (j = 1; j < ll; j++) {
            c = document.createElement("DIV");
            c.innerHTML = selElmnt.options[j].innerHTML;
            c.addEventListener("click", function(e) {
                let y, i, k, s, h, sl, yl;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                sl = s.length;
                h = this.parentNode.previousSibling;
                for (i = 0; i < sl; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {
                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        y = this.parentNode.getElementsByClassName("same-as-selected");
                        yl = y.length;
                        for (k = 0; k < yl; k++) {
                            y[k].removeAttribute("class");
                        }
                        this.setAttribute("class", "same-as-selected");
                        break;
                    }
                }
                h.click();
            });
            b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function(e) {
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
        });
    }

    function closeAllSelect(elmnt) {
        let x, y, i, xl, yl, arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        xl = x.length;
        yl = y.length;
        for (i = 0; i < yl; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i)
            } else {
                y[i].classList.remove("select-arrow-active");
            }
        }
        for (i = 0; i < xl; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add("select-hide");
            }
        }
    }

    document.addEventListener("click", closeAllSelect);
}

document.addEventListener('DOMContentLoaded', () => {
    //changeProductColorOptions();
   // changeProductSizeOptions();
    customSelect();
    changeGridView();
     //shopBlockToggle();
    sortBlockToggle();
    scrollTop();
    hideBanner();
    cartModal();
    searchModal();
    menuToggle();
    //cookieModal();
   // newsModal();
    tableToggle();
    //profileMenuToggle();
   // orderToggle();
    addressToggle();
    productGallery();
    changeGridViewchecker();
    productclick();
    modalStarter(".btn-shipping", "#modal-shipping", ".shipping__close-btn", ".shipping");
    modalStarter(".product__size-guide", "#modal-size", ".size__close-btn", ".size");
    modalStarter(".filter__trigger", "#modal-filter", ".js-filter__close", ".filter__block");
    modalStarter(".btn-notify", "#modal-notify", ".notify__close-btn", ".notify");
   
    let viewLargeBtn = document.querySelector(".btn-view-lg");
    let largeMode = localStorage.getItem('largeMode'); 
    if(largeMode === 'enabled'){
    }else{
        if( viewLargeBtn ) {
            viewLargeBtn.classList.toggle("btn-view-lg--active")
        }
    }
  
  
    if (window.Swiper) {
        const styledWithCount = $('.product-styled--mobile .product-description-slider .product-card').length;
        
        const productSwiper1 = new Swiper('.product-description-slider', {
            loop: styledWithCount > 3,
            slidesPerView: 3,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                1080: {
                    slidesPerView: 3,
                },
                768: {
                    slidesPerView: 3,
                },
                0: {
                    slidesPerView: 2,
                }
            }
        });

        const productSwiper2 = new Swiper('.product-mob-slider', {
            loop: true,
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                767: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                    pagination: false,
                },
                769: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
            }
        });
    }

    // removing flexmasonry for ajaxinate to work properly

    if (window.FlexMasonry) {
        FlexMasonry.init('.journal__wrapper', {
            responsive: true,
            breakpointCols: {
                'min-width: 1400px': 4,
                'min-width: 1200px': 4,
                'min-width: 992px': 3,
                'min-width: 768px': 3,
                'min-width: 576px': 2,
                'min-width: 320px': 2,
            },
        });
    }

    // if (window.FlexMasonry) {
        
    // }
});

function productclick() {
/**
 * Making whole product card clickable.
 */

 document.querySelectorAll('.product-card').forEach(function(product) {
    const link = product.querySelector('.product-card__title > a');
    if( link ) {
        product.addEventListener('click', function() {
            link.click();
        });
    }
})

/**
 * Mobile Custom-Selectbox
 */
document.querySelectorAll('.mobile-select__close').forEach(el => {
    const mainEl = el.closest('.mobile-select');

    el.addEventListener('click', function(e) {
        e.preventDefault();
        mainEl.classList.remove('mobile-select--active');
    });
})

document.querySelectorAll('.mobile-select__options').forEach(el => {
    const mainEl = el.closest('.mobile-select');

    el.addEventListener('click', function(e) {
        mainEl.classList.remove('mobile-select--active');
    });
})


document.querySelectorAll('.mobile-select__trigger').forEach(el => {
    const target = document.querySelector( el.getAttribute('data-target') );
    if( target ) {
        el.addEventListener('click', function() {
            console.log(el);
            target.classList.add('mobile-select--active');
        });
    }
});


/**
 * Syncing the value of mobile select triggers
 */
const sizeSync = document.querySelector('.size-sync');
if( sizeSync ) {
    document.querySelectorAll('.m-size').forEach(el => {
        el.addEventListener('change', function() {
            sizeSync.innerHTML = this.value;
            
            if( $(this).hasClass('is-disabled') ) {
                $('.mobile-selectedVariant').addClass('is-disabled');
            } else {
                $('.mobile-selectedVariant').removeClass('is-disabled');
            }
            
            $('.mobile-selectedVariant').val( $(el).attr('data-variantid') ).trigger('change');
            
        });
    })
}

const colorSync = document.querySelector('.color-sync');
if( colorSync ) {
    document.querySelectorAll('[name=color]').forEach(el => {
        el.addEventListener('change', function() {
            colorSync.innerHTML = this.value;
        });
    })
}


    
}




function productGallery() {
    const wrapper = document.querySelector('.product-gallery__wrapper');
    if(!wrapper) return;

    const images = wrapper.querySelectorAll('.product-gallery__image');
    const thumbs = wrapper.querySelectorAll('.product-gallery__thumb');
    
    let activeThumbPast = -1;
    let activeThumb = 0;

    wrapper.addEventListener('scroll', () => {
        const wrapperTop = wrapper.scrollTop;
        
        images.forEach( (image, index) => {
            if( wrapperTop >= image.offsetTop ) {
                activeThumb = index;
            }
        });

        
    })

    thumbs.forEach( (thumb, index) => {
        thumb.addEventListener('click', () => { 
            wrapper.scrollTo({
                top: images[index].offsetTop,
                behavior: 'smooth' 
            })
        });
    });

    document.querySelectorAll('.product-gallery__close').forEach(close => {
        close.addEventListener('click', () => {
            document.querySelectorAll('.product-gallery.active').forEach(gallery => {
                gallery.classList.remove('active');
            })
        });
    })

    document.querySelectorAll('.product-gallery__trigger').forEach(el => {
        el.addEventListener('click', () => {
            document.querySelector('.product-gallery').classList.add('active');
        })
    });
    
}

